"use client"

import { ShoppingCart } from "@medusajs/icons"
import { useCartDrawer } from "@modules/cart-drawer/context/cart-drawer-context"
import styles from "./cart-button.module.css"

export default function CartButton() {
  const { model, openCart } = useCartDrawer()

  return (
    <button
      type="button"
      className={styles.cartButton}
      data-testid="nav-cart-link"
      onClick={openCart}
      aria-label={`Sepet, ${model.itemCount} ürün`}
    >
      <ShoppingCart aria-hidden="true" className="h-[24px] w-[24px]" />
      {model.itemCount > 0 && (
        <span className={styles.quantity}>
          <p>{model.itemCount}</p>
        </span>
      )}
    </button>
  )
}
